/**
 * Created by user on 2020/6/10.
 */

export const SYMBOL_RAW_DATA = Symbol.for('rawData');

